export class Register {
   'firstname' = '';
   'lastname' = '';
   'email'  = '';
   'phone' = '';
   'password' = '';
   'gender'= '';
   'dob'='';
   'otp'='';


}